import AssignmentFeedback from 'models/assignments/AssignmentFeedback';
import React, { createContext, useContext, ReactNode, useState } from 'react';

interface AssignmentFeedbackContextType {
  feedback: AssignmentFeedback[];
  setFeedback: React.Dispatch<React.SetStateAction<AssignmentFeedback[]>>;
}

const AssignmentFeedbackContext = createContext<
  AssignmentFeedbackContextType | undefined
>(undefined);

export function useAssignmentFeedbackContext() {
  const context = useContext(AssignmentFeedbackContext);
  if (context === undefined) {
    throw new Error(
      'useAssignmentFeedbackContext must be used within a AssignmentFeedbackProvider',
    );
  }
  return context;
}

interface AssignmentFeedbackProviderProps {
  children: ReactNode;
}

export function AssignmentFeedbackProvider({
  children,
}: AssignmentFeedbackProviderProps) {
  const [feedback, setFeedback] = useState<AssignmentFeedback[]>([]);

  return (
    <AssignmentFeedbackContext.Provider value={{ feedback, setFeedback }}>
      {children}
    </AssignmentFeedbackContext.Provider>
  );
}
